import { Avatar, Box, Button, Chip, Divider, Grid, Stack, Typography } from "@mui/material"
import useStyles from '../../../../../styles/global-mui.js';
import { useDirect } from "../DirectContext.js"
import { useScoreResolver } from "../../../../hooks/useScoreResolver.js"
import Chrono from "./Chrono.js"
import { confirmActionNotification } from "../../../../../actions/notifications.js"
import { forfaitMatch, updateMatch } from "../../../../../actions/matchs.js"
import { useDispatch } from "react-redux"

/**
 * MatchHeader is a React functional component that displays the header section for a match.
 * It shows both teams' names, logos (or colors), score, and provides buttons to report or forfeit the match.
 * The component uses hooks for state management and dispatches Redux actions for match updates.
 * Props:
 *   - handleEventClick: function to handle chrono event clicks.
 */
const MatchHeader = ({handleEventClick}) => {

    const classes = useStyles();

    const dispatch = useDispatch()
    const match = useDirect()

    const [homeScore, awayScore, , , homeShoutoutSucceed, awayShoutoutSucceed] = useScoreResolver(match)


    const matchReported = () => {
        // On passe le status du match à "reported"
        dispatch(confirmActionNotification("Confirmer le report du match", () => dispatch(updateMatch(match.idMatch, {status : 'reported'}))))
    }

    const matchForfait = (team) => {
        dispatch(confirmActionNotification("Confirmer le forfait de : "+team.name, () => dispatch(forfaitMatch(match.idMatch, team._id))))
    }

    return (
  <>
        <Grid className='shadow-wrapper' container>
            {/**HOMETEAM PART*/}
            <Grid item xs="5" justifyItems={'center'} textAlign={'center'}>
                <Box sx={{display:'inline-grid', justifyItems:'center'}}>
                    <Box className='small-padding-wrapper'>
                        {/*Forfait button */}
                        <Button sx={{ p: '4px', minWidth: 'auto', fontSize : '0.7em', lineHeight : '0.8em', inlineSize: 'fit-content' }} disabled={match.period === 2} variant='contained' size='small' onClick={() => matchForfait(match.homeTeam)}>Forfait</Button>
                    </Box>
                    {/*Hometeam */}
                    <Box className='centered-wrapper'>
                        {/*Display logo, or hometeam color or default grey*/}
                        {match.homeTeam.logoUrl ? 
                            <img src={match.homeTeam.logoUrl} 
                            alt={'logo'}
                            style={{height:'27px', 
                                width:'27px', 
                                border:'1px solid var(--color-dark-grey)'}}>
                            </img>
                        :
                            <Box 
                                sx={{height:'27px', 
                                width:'27px', 
                                border:'1px solid var(--color-dark-grey)', 
                                backgroundColor:`${match.homeTeam.color ? match.homeTeam.color : 'var(--color-light-grey)'}`}}>
                            </Box>
                           } 
                           {/*Team name*/}
                           <Box sx={{
                            display: 'flex',
                            alignContent: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center'
                           }}>
                                <Typography sx={{textTransform:'uppercase', paddingLeft:'10px'}} className={classes.customInputLabel} >{match.homeTeam.name}</Typography>
                                {match.homeTeam.logoUrl && 
                                    <Box sx={{width: '93%',
                                        height: '3px',
                                        backgroundColor: `${match.homeTeam.color ? match.homeTeam.color : 'var(--color-light-grey)'}`,
                                        marginLeft: '10px'}}>
                                    </Box>
                                }
                           </Box>
                    </Box>
                </Box>
                <Box className='padding-wrapper'></Box>
            </Grid>
            {/**MATCH PART*/}
            <Grid item xs="2" justifyItems={'center'} textAlign={'center'}>
                <Box sx={{display:'inline-grid', justifyItems:'center'}}>
                    {/*reported button*/}
                    <Box className='small-padding-wrapper'>
                        <Button sx={{ p: '4px', minWidth: 'auto', fontSize : '0.7em', lineHeight : '0.8em', inlineSize: 'fit-content'  }} disabled={match.status === 'reported' || match.status === 'end' ||match.period === 2 || match.period === 6} variant='contained' size='small' onClick={matchReported}>Reporté</Button>
                    </Box>
                    {/*Score*/}
                  
                            <Box display={"flex"} flexDirection={"column"}>
                                <Box display="flex" className='centered-wrapper' justifyContent={"space-evenly"} minHeight={'27px'}>
                                    <Typography fontWeight='bold' fontSize='1.2rem' className={classes.customInputLabel}>{homeScore} - {awayScore}</Typography>
                                </Box>
                                {(homeShoutoutSucceed > 0 || awayShoutoutSucceed > 0) && 
                                <Box display="flex" alignItems={"center"} justifyContent={"space-evenly"}>
                                    <Typography variant="body1">{homeShoutoutSucceed}</Typography>
                                    <Typography sx={{fontSize : '1em'}}>t.a.b</Typography>
                                    <Typography variant="body1">{awayShoutoutSucceed}</Typography>
                                </Box>}
                            </Box>
                      
                    </Box>
                    <Box className='padding-wrapper'></Box>
            </Grid>
            {/**AWAYTEAM PART*/}
            <Grid item xs="5" justifyItems={'center'} textAlign={'center'}>
                <Box sx={{display:'inline-grid', justifyItems:'center'}}>
                    <Box className='small-padding-wrapper'>
                        {/*Forfait button */}
                        <Button sx={{ p: '4px', minWidth: 'auto', fontSize : '0.7em', lineHeight : '0.8em', inlineSize: 'fit-content'  }} disabled={match.period === 2} variant='contained' size='small' onClick={() => matchForfait(match.awayTeam)}>Forfait</Button>
                    </Box>
                    {/*Awayteam */}
                    <Box className='centered-wrapper'>
                        {/*Team name*/}
                         <Box sx={{
                            display: 'flex',
                            alignContent: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center'
                           }}>
                                <Typography sx={{textTransform:'uppercase', paddingRight:'10px'}} className={classes.customInputLabel} >{match.awayTeam.name}</Typography>
                                {match.awayTeam.logoUrl && 
                                    <Box sx={{width: '93%',
                                        height: '3px',
                                        backgroundColor: `${match.awayTeam.color ? match.awayTeam.color : 'var(--color-light-grey)'}`,
                                        marginRight: '10px'}}>
                                    </Box>
                                }
                           </Box>
                        {/*Display logo, or awayteam color or default grey*/}
                        {match.awayTeam.logoUrl ? 
                            <img src={match.awayTeam.logoUrl} 
                            alt={'logo'}
                            style={{height:'27px', 
                                width:'27px', 
                                border:'1px solid var(--color-dark-grey)'}}>
                            </img>
                        :
                            <Box 
                                sx={{height:'27px', 
                                width:'27px', 
                                border:'1px solid var(--color-dark-grey)', 
                                backgroundColor:`${match.awayTeam.awayColor ? match.awayTeam.awayColor : 'var(--color-light-grey)'}`}}>
                            </Box>
                           } 
                    </Box>
                </Box>
                <Box className='padding-wrapper'></Box>
            </Grid>
        </Grid>

        <Box className='small-padding'></Box>
        
        <Box className='centered-wrapper'>
            <Chrono handleEventClick={handleEventClick}/>
        </Box>

        <Box className='small-padding'></Box>
        
</>
    )

}

export default MatchHeader